import clsx from 'clsx';
import styles from '../style.module.scss';
import { useContextSystem } from '../../context';
export function useBorderBoxControlLinkedButton(props) {
  const {
    className,
    ...otherProps
  } = useContextSystem(props, 'BorderBoxControlLinkedButton');
  return {
    ...otherProps,
    className: clsx(styles['linked-button'], className)
  };
}